import {DomainObject, oneOf} from 'shared/store';
import {t} from 'shared/core';
import { observable, action, computed, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import {User} from 'main/stores/users';
import TimeTrackingPaySchedule from './TimeTrackingPaySchedule';
import {TimeOffType} from 'main/stores/time_off';

class TimeTrackingPolicy extends DomainObject {
  name;
  state;

  overtimePolicy;
  weeklyOvertimeThreshold;
  dailyOvertimeThreshold;
  dailyDoubleOvertimeThreshold;
  weekStartDay;
  sendApprovedTimesheetEditedNotification;
  sendPayPeriodEndedNotification;
  sendEmployeeTimesheetReminder;

  paySchedule;
  employees;
  assigneeType;
  assigneeUser;

  manuallyEnterHours;

  lieuTimeEnabled;
  lieuTimeMultiplier;
  lieuTimeDoubleMultiplier;
  lieuTimePTOType;

  timeClockEnabled;
  collectEmployeeLocation;
  timeClockLocation;
  geofencingEnabled;

  _relations = {
    paySchedule: TimeTrackingPaySchedule,
    employees: [Employee],
    assigneeUser: User,
    lieuTimePTOType: TimeOffType,
    overtimePolicy: oneOf(['standard', 'custom', 'exempt']),
    assigneeType: oneOf(['manager', 'specific_user'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      state: observable,
      overtimePolicy: observable,
      weeklyOvertimeThreshold: observable,
      dailyOvertimeThreshold: observable,
      dailyDoubleOvertimeThreshold: observable,
      weekStartDay: observable,
      sendApprovedTimesheetEditedNotification: observable,
      sendPayPeriodEndedNotification: observable,
      sendEmployeeTimesheetReminder: observable,
      paySchedule: observable,
      employees: observable,
      assigneeType: observable,
      assigneeUser: observable,
      manuallyEnterHours: observable,
      lieuTimeEnabled: observable,
      lieuTimeMultiplier: observable,
      lieuTimeDoubleMultiplier: observable,
      lieuTimePTOType: observable,
      timeClockEnabled: observable,
      collectEmployeeLocation: observable,
      timeClockLocation: observable,
      geofencingEnabled: observable,
      setManuallyEnteredHours: action,
      setTimeClockEnabled: action,
      setCollectEmployeeLocation: action,
      setTimeClockLocation: action,
      hoursEnteredAsLabel: computed
    });

    this.merge(other);
  }

  setManuallyEnteredHours(value) {
  if (value) {
    this.merge({
      manuallyEnterHours: true,
      timeClockEnabled: false,
      collectEmployeeLocation: false,
      geofencingEnabled: false,
      timeClockLocation: null,
    });
  } else {
    this.merge({
      manuallyEnterHours: false,
      timeClockEnabled: true
    });
  }
}

  setTimeClockEnabled(value) {
      if (value) {
        this.merge({
          timeClockEnabled: true,
        });
      } else {
        this.merge({
          timeClockEnabled: false,
          collectEmployeeLocation: false,
          geofencingEnabled: false,
          timeClockLocation: null
        });
      }
    }

  setCollectEmployeeLocation(value) {
    if (value) {
      this.merge({
        collectEmployeeLocation: true,
      });
    } else {
      this.merge({
        collectEmployeeLocation: false,
        geofencingEnabled: false,
        timeClockLocation: null
      });
    }
  }

  setTimeClockLocation(value) {
    if (value) {
      this.merge({
        timeClockLocation: value
      });
    } else {
      this.merge({
        timeClockLocation: null,
        geofencingEnabled: false
      });
    }
  }

  get hoursEnteredAsLabel() {
    return this.manuallyEnterHours ?
      t('time_tracking.manage.policies.edit.Total Hours'):
      t('time_tracking.manage.policies.edit.Start and End Time');
  }
}

export default TimeTrackingPolicy;
